// studio-straf.js is located in /assets

$(document).ready(function(){

  //
  $('.readmore').on('click',function(){
  	// $(this).toggleClass('open');
    $(this).find('p').toggle(300);
  })
  
});